import { usePostApiV1ThreeLetterCodeClientAdminsClientAdminUsers } from '@fukuri-admins/apis/client/gen/endpoints';

export const useCreateClientAdminUser = usePostApiV1ThreeLetterCodeClientAdminsClientAdminUsers;
